module.exports = __webpack_public_path__ + "feather.34f9a3a990e508eb257a.woff";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/feather/fonts/feather.woff?9xfrq8
// module id = ../../../../../src/assets/fonts/feather/fonts/feather.woff?9xfrq8
// module chunks = styles